export enum LivanceApiErrorTypes {
  ValidationError = "ValidationError",
  RepeatedPatientError = "RepeatedPatientError",
}
